import { Api } from 'helpers/ApiClient';

export class Styles {
  static async getAllStyles(id) {
    try {
      const response = await Api.client.get(
        `/api/v1/accounts/${id}/style.json`,
      );
      return response.data;
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error getAllStyles',
      };
    }
  }

  static async updateTheme(id, param) {
    try {
      const response = await Api.client.put(
        `/api/v1/accounts/${id}/style/select_theme`,
        param,
      );
      return {
        message: response.data.message,
        status: response.status,
      };
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error updateTheme',
      };
    }
  }

  static async updateBackground(id, param) {
    try {
      let dataResponse;
      if (param.background.image) {
        const formDataParams = new FormData();
        formDataParams.append('background[image]', param.background.image);
        formDataParams.append('background[overlay_type]', 'image');
        formDataParams.append('background[overlay_value]', null); //TODO: need ti fix
        dataResponse = formDataParams;
      } else {
        dataResponse = param;
      }
      const response = await Api.client.put(
        `/api/v1/accounts/${id}/style/update_background`,
        dataResponse,
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error updateBackground',
      };
    }
  }

  static async updateTextColor(id, param) {
    try {
      const response = await Api.client.put(
        `/api/v1/accounts/${id}/style/update_text_color`,
        param,
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error updateTextColor',
      };
    }
  }

  static async updateButton(id, param) {
    try {
      const response = await Api.client.put(
        `/api/v1/accounts/${id}/style/update_button`,
        param,
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error updateButton',
      };
    }
  }

  static async updateImageLink(id, param) {
    try {
      const response = await Api.client.put(
        `/api/v1/accounts/${id}/style/update_image_link`,
        param,
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error updateImageLink',
      };
    }
  }

  static async updateShowFooter(id, param) {
    try {
      const response = await Api.client.put(
        `/api/v1/accounts/${id}/style/toggle_footer`,
        param,
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error updateShowFooter',
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/styles/api.js